import { Route, Routes } from "react-router-dom";

import A9Portfolios from "./A9Portfolios/main";
import A9StaticData from "./A9StaticData/main";
import A9TimeSeries from "./A9TimeSeries/main";
import A9Transactions from "./A9Transactions/main";
import A9DataUpload from "./A9DataUpload/main";
import A9Issuers from "./A9Issuers/main";

export default function A9Routes() {
  return (
    <Routes>
      <Route path="a9_portfolios/*" element={<A9Portfolios />} />
      <Route path="a9_static_data/*" element={<A9StaticData />} />
      <Route path="a9_time_series/*" element={<A9TimeSeries />} />
      <Route path="a9_transactions/*" element={<A9Transactions />} />
      <Route path="a9_data_upload/*" element={<A9DataUpload />} />
      <Route path="a9_issuers/*" element={<A9Issuers />} />
    </Routes>
  );
}
